module.exports = __webpack_public_path__ + "fonts/Lexend-Thin.4c9809c.woff2";